export const DEFAULT_VOICE_AGENDA_COMMIT_COMMANDS = [
  'done adding items',
  'finished',
  'done',
  'send',
  'confirm',
]
export const DEFAULT_VOICE_AGENDA_CLEAR_COMMANDS = ['start over', 'delete']

function formatVoiceCommands(commands: string[]): string {
  return commands
    .filter(Boolean)
    .map((command) => command.charAt(0).toUpperCase() + command.slice(1))
    .join(', ')
}

export function getVoiceAgendaCommitCommands(): string[] {
  return [...DEFAULT_VOICE_AGENDA_COMMIT_COMMANDS]
}

export function getVoiceAgendaClearCommands(): string[] {
  return [...DEFAULT_VOICE_AGENDA_CLEAR_COMMANDS]
}

export function formatVoiceAgendaCommitCommands(commands: string[]): string {
  return formatVoiceCommands(commands)
}

export function formatVoiceAgendaClearCommands(commands: string[]): string {
  return formatVoiceCommands(commands)
}
